var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7456 22.2179L29.7438 19.6396C33.4622 19.6396 36.4858 16.616 36.4858 12.8994V5.95328H30.7032V3.375H39.064V12.8995C39.064 18.0377 34.8838 22.2179 29.7456 22.2179Z",
    fill: "#FFF16B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7456 22.2179L29.7438 19.6396C33.4622 19.6396 36.4858 16.616 36.4858 12.8994V5.95328H30.7032V3.375H39.064V12.8995C39.064 18.0377 34.8838 22.2179 29.7456 22.2179Z",
    fill: "#FFD321"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2544 22.2179C5.11613 22.2179 0.935974 18.0377 0.935974 12.8994V3.375H9.29509V5.95328H3.51425V12.8995C3.51425 16.6161 6.53788 19.6397 10.2544 19.6397V22.2179Z",
    fill: "#FFF16B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8168 25.5127H24.1814V39.1777H15.8168V25.5127Z",
    fill: "#FFF16B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9991 25.5127H24.1815V39.1777H19.9991V25.5127Z",
    fill: "#FFD321"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00586 0V16.4937C8.00586 23.1067 13.386 28.4869 19.9991 28.4869C26.6121 28.4869 31.9923 23.1067 31.9923 16.4937V0H8.00586Z",
    fill: "#FFD321"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9923 16.4937V0H19.9991V28.4869C26.6122 28.4869 31.9923 23.1067 31.9923 16.4937Z",
    fill: "#FFAF00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2539 36.5996H28.7444V43.9999H11.2539V36.5996Z",
    fill: "#FFD321"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9991 36.5996H28.7444V43.9999H19.9991V36.5996Z",
    fill: "#FFAF00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0891 10.9276L22.1938 10.2106L19.9991 5.77637L17.8044 10.2106L12.9091 10.9276L16.448 14.3851L15.6172 19.2624L19.9991 16.9651L24.3809 19.2624L23.5501 14.3851L27.0891 10.9276Z",
    fill: "#FFF16B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5501 14.3851L27.0891 10.9276L22.1938 10.2106L19.9991 5.77637V16.9651L24.3809 19.2624L23.5501 14.3851Z",
    fill: "#FFD321"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.c21426b0ee196f1abe1ed29092f74568.svg";
export { ForwardRef as ReactComponent };